import * as actionTypes from './actionTypes'

const initialState = {
    syllabusData: [],
    progress: 0
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.UPDATE_SYLLABUS:
            state = {
                ...state,
                syllabusData: action.payload.data,
            }
            break;
        case actionTypes.UPDATE_PROGRESS:
            return {
                ...state,
                progress: action.payload,
            }
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default reducer;
